import * as React from 'react';
import { Card, Box, Typography, Alert } from '@mui/material';
import CaptureCode from '../components/CaptureCode';
import { usePaymentContext } from '../context';

export default function LandingPage() {
    const paymentContext = usePaymentContext();

    return (
        <>
            <Box textAlign="left">
                <Typography variant="h2" gutterBottom>Thank you for choosing to make your claim payment online</Typography>
                <Typography variant="h6" gutterBottom>To make your payment, please enter the code you have been given and click begin.</Typography>
            </Box>
            <Box textAlign="center">
            </Box>

            <Card>
                <Box p={3} display="flex" flexGrow="1" justifyContent="center" textAlign="center">
                    <Box width={1}>
                        {
                            (paymentContext.hasInvalidCode) &&
                            <Box mb={3}>
                                <Alert severity="error">There appears to be an issue with the code. Please re-enter the code and try again. Please note that the code is case-sensitive.</Alert>
                            </Box>
                        }

                        <CaptureCode />
                    </Box>
                </Box>
            </Card>
        </>
    )
}
